<template>
  <div class="notaria-container" v-if="systemConfig.indexStyle == 1 || systemConfig.indexStyle == 2">
    <IndexHeader ref="IndexHeader"></IndexHeader>
<!--    <div class="banner">-->
<!--      <div class="title-box">-->
<!--      </div>-->
<!--      <img :src="$store.getters.systemConfig.indexHeaderImgUrl" alt="">-->
<!--    </div>-->
    <div class="banner"
         :style="{backgroundImage: 'url(' + (systemConfig.indexHeaderImgUrl ? systemConfig.indexHeaderImgUrl : '../../static/img/bg.png') + ')', backgroundSize:'100% 100%',repeat:'no-repeat',}">
      <div class="left company_name" key="5">
        <p class="p1">一站式互联网公证平台</p>
        <p class="p2">互联网 + 区块链 + 公证，申请、受理、审核、出证、回访、送达在线完成</p>
      </div>
    </div>

    <div class="new-content" v-if="$store.getters.systemConfig.indexStyle == 1">
      <div class="new-card" style="margin-bottom: 80px" v-if="(showMenus & 2) === 2">
        <p class="title-p">常规公证</p>
        <p class="cont-p">用户通过互联网在线办理委托公证、赋强公证、股东会决议公证、签名、印章公证、夫妻财产约定公证、租赁合同</p>
        <p class="cont-p">公证等事项，全流程线上完成，足不出户即可拿到公证书。</p>
        <div class="part" v-if="notarList.length >0">
          <div class="list" @click="gotoZZ(item.id)" v-for="(item,index) in notarList" :key="index">
            <img :src="require('../../static/img/' + imgList[index].url +'.png')" style="width: 69px">
            <p>{{item.businessName}}</p>
          </div>

        </div>
        <div class="part" v-else>
          <p class="btn" @click="gotoZZ('')">立即前往办理>></p>
        </div>
      </div>
<!--      <div class="new-card fq-bj" style="margin-top: 50px" v-if="(showMenus & 2) == 2">-->
<!--        <p class="title-p">赋强公证</p>-->
<!--        <p class="cont-p">具有强制执行效力的债权文书公证书。网络赋强公证，就是由公证机构对借贷双方之间签署的电子借贷合同进行在线公证，</p>-->
<!--        <p class="cont-p">并赋予公证书强制执行效力。具有免诉执行、高效率处置借贷纠纷的特色优势。</p>-->
<!--        <div class="part" v-if="notarList.length >0">-->
<!--          <div class="list" @click="gotoFQ(item.id)" v-for="(item,index) in notarList" :key="index">-->
<!--            <img :src="require('../../static/img/' + imgList[index].url +'.png')" style="width: 69px">-->
<!--            <p>{{item.businessName}}</p>-->
<!--          </div>-->

<!--        </div>-->
<!--        <div class="part" v-else>-->
<!--          <p class="btn" @click="gotoFQ('')">立即前往办理>></p>-->
<!--        </div>-->
<!--      </div>-->
      <div class="new-card fq-bj" v-if="(showMenus & 8) == 8 || (showMenus & 16) == 16">
        <p class="title-p">存证公证</p>
        <p class="cont-p">电子数据区块链存证公证。数据存证公证是指将容易被抹灭、篡改的网络数据在产生那一刻开始，存证于公证处的区块链节点上。</p>
        <p class="cont-p">避免发生纠纷后难以提取有效证据，达到事前预防，事后快速出具存证公证书的目的。</p>
        <div class="part">
          <p class="btn" @click="gotoFQ">立即前往办理>></p>
        </div>
      </div>
      <div class="new-card">
        <p class="title-p">提存公证</p>
        <p class="cont-p">是公证机关依照法定条件和程序，对交付的提存物进行寄托、保管，并在条件成熟时交付债权人或其他受益人的活动。</p>
        <div class="part">
          <p class="btn" @click="gotoTC">立即前往办理>></p>
        </div>
      </div>
      <div class="new-card gz-dzq" style="margin-top: 50px" v-if="(showMenus & 4) == 4">
        <p class="title-p">公证电子签</p>
        <p class="cont-p">公证电子签名利用电子公证技术将公证机构设置为多方节点的其中一个，由公证机构参与、见证并且为用户的签名提供公证证明，为企业提供</p>
        <p class="cont-p">一步到位的抗抵赖的签署服务。</p>

        <div class="part">
          <p class="btn" @click="gotoDZQ('')">立即前往办理>></p>
        </div>
      </div>
      <div class="new-card" v-if="(showMenus & 32) == 32">
        <p class="title-p">公证取证</p>
        <p class="cont-p">公证取证是指由公证机构依法对特定证据进行固定、保全的过程，以确保证据的真实性、合法性和有效性。</p>
        <p class="cont-p">这一程序常见于法律纠纷中，尤其是在证据可能灭失或难以获取的情况下，通过公证手段强化证据的法律效力。</p>
        <div class="part">
          <p class="btn" @click="gotoCZ">立即前往办理>></p>
        </div>
      </div>



    </div>
    <div class="cards" v-else>
      <div class="card" v-if="(showMenus & 2) == 2">
        <img src="../../static/img/new-1.png" alt="">
        <div class="card-title">常规公证</div>
        <p class="card-content">
          用户通过互联网在线办理委托公证、赋强公证、股东会决议公证、签名、印章公证、夫妻财产约定公证、租赁合同公证等事项，全流程线上完成，足不出户即可拿到公证书。
        </p>
        <div class="btn-box">
          <el-button class="card-btn" type="text" @click="gotoFQ('')">
            立即办理
          </el-button>
          <el-button class="card-btn" type="text" @click="notariaLogin">
            公证员入口
          </el-button>
        </div>
      </div>



      <div class="card" v-if="(showMenus & 8) == 8 || (showMenus & 16) == 16">
        <img src="../../static/img/new-2.png" alt="">
        <div class="card-title">存证公证</div>
        <p class="card-content">
          数据存证公证是指将容易被抹灭、篡改的网络数据在产生那一刻开始，存证于公证处的区块链节点上。避免发生纠纷后难以提取有效证据，达到事前预防，事后快速出具存证公证书的目的。
        </p>
        <div class="btn-box">
          <el-button class="card-btn" type="text" @click="gotoCZ">
            立即办理
          </el-button>
          <el-button class="card-btn" type="text" @click="notariaLogin">
            公证员入口
          </el-button>
        </div>
      </div>





      <div class="card">
        <img src="../../static/img/new-5.png" alt="">
        <div class="card-title">提存公证</div>
        <p class="card-content">
          是公证机关依照法定条件和程序，对交付的提存物进行寄托、保管，并在条件成熟时交付债权人或其他受益人的活动。
        </p>
        <div class="btn-box">
          <el-button class="card-btn" type="text" @click="gotoTC">
            立即办理
          </el-button>
          <el-button class="card-btn" type="text" @click="notariaLogin">
            公证员入口
          </el-button>
        </div>
      </div>

      <div class="card" v-if="(showMenus & 4) == 4">
        <img src="../../static/img/new-4.png" alt="">
        <div class="card-title">公证电子签</div>
        <p class="card-content">
          公证电子签名利用电子公证技术将公证机构设置为多方节点的其中一个，由公证机构参与、见证并且为用户的签名提供公证证明，为企业提供步到位的抗抵赖的签署服务。
        </p>
        <div class="btn-box">
          <el-button class="card-btn" type="text" @click="gotoDZQ">
            立即办理
          </el-button>
          <el-button class="card-btn" type="text" @click="notariaLogin">
            公证员入口
          </el-button>
        </div>
      </div>
      <div class="card" v-if="(showMenus & 32) == 32">
        <img src="../../static/img/new-3.png" alt="">
        <div class="card-title">公证取证</div>
        <p class="card-content">
          公证取证是指由公证机构依法对特定证据进行固定、保全的过程，以确保证据的真实性、合法性和有效性。这一程序常见于法律纠纷中，尤其是在证据可能灭失或难以获取的情况下，通过公证手段强化证据的法律效力。
        </p>
        <div class="btn-box">
          <el-button class="card-btn" type="text" @click="gotoZZ('')">
            立即办理
          </el-button>
          <el-button class="card-btn" type="text" @click="notariaLogin">
            公证员入口
          </el-button>
        </div>
      </div>

    </div>


    <div class="map" :style="{'background-image':`url('${$store.getters.systemConfig.indexBottomImgUrl}')`}">
      <div class="map-box">
        <div
          style="width:70%;height:280px;margin-left: 55px;display: inline-block;box-sizing: border-box;border: 8px solid #5b5b5b;"
          id="map"></div>
        <div class="map-info">
          <div class="info-item">
            <div class="info-incon">
              <img src="../../static/img/phone.png" alt="">
            </div>
            <div class="info-content">
              <div class="content-title">咨询电话：</div>
              <div class="content">{{$store.getters.systemConfig.notaryPhone}}</div>
            </div>
          </div>
          <div class="info-item">
            <div class="info-incon">
              <img src="../../static/img/time.png" alt="">
            </div>
            <div class="info-content">
              <div class="content-title">办公时间：</div>
              <div class="content">周一至周五 上午：9:00-12:00<br>下午：15：00-18:00</div>
            </div>
          </div>
          <div class="info-item">
            <div class="info-incon">
              <img src="../../static/img/addr.png" alt="">
            </div>
            <div class="info-content">
              <div class="content-title">本处地址：</div>
              <div class="content">{{$store.getters.systemConfig.notaryAddress}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <index-footer></index-footer>

    <div v-show="modelShow"
         style="width: 100%;height: 100%;background: rgba(0,0,0,0.4);z-index: 2000;display: flex;justify-content: center;align-items: center;position: fixed;top: 0;left: 0">
      <div style="width: 480px;height: 300px;border-radius: 10px;background: #ffffff">
        <el-row
          style="border-bottom: 1px solid #EEEEEE;height: 50px;font-size: 16px;font-weight: 600;color: rgba(0,0,0,0.85);line-height: 50px;padding-left: 20px">
          友情提示
        </el-row>
        <el-row style="height: 190px;position: relative">
          <img src="../../static/img/construction.png"
               style="width: 233px;height: 131px;position: absolute;top: 34px;left: 52px;">
          <p
            style="display: block;position: absolute;top: 90px;left: 266px;font-size: 14px;line-height: 20px;color: rgba(0,0,0,0.85);font-weight: 500;width: 26%">
            建设中，尽请期待...</p>
        </el-row>
        <el-row style="height: 60px;position: relative">
          <el-button type="text" class="cancelbtn" @click="cancelModel">取消</el-button>
          <el-button class="confirmbtn" @click="cancelModel">确定</el-button>
        </el-row>
      </div>
    </div>
  </div>
  <div class="notaria-container" v-else-if="systemConfig.indexStyle == 3"
       :style="{backgroundImage: 'url(' + (systemConfig.indexHeaderImgUrl ? systemConfig.indexHeaderImgUrl : '../../static/img/bg.png') + ')', backgroundSize:'100% 100%',repeat:'no-repeat',}">


    <IndexHeader ref="IndexHeader2" :headerBackgroundColor="headerBackgroundColor"
                 :menuBackgroundColor="menuBackgroundColor"
                 :defaultTextColor="defaultTextColor" :txtTitle="txtTitle" :btnColor="btnColor"></IndexHeader>
    <div class="cont2">
      <div class="part company_name" v-if="indexTab == 'tab1'" key="1">
        <p><span style="color: #FF0000">常规</span>公证</p>
        <p style="margin: 20px 0;font-size: 20px">用户通过互联网在线办理委托公证、赋强公证、股东会决议公证、签名、印章公证、夫妻财产约定公证、</p>
        <p style="font-size: 20px">租赁合同公证等事项，全流程线上完成，足不出户即可拿到公证书。</p>
        <div class="part-cont" v-if="notarList.length >0">
          <div class="list" @click="gotoZZ(item.id)" v-for="(item,index) in notarList" :key="index">
            <img :src="require('../../static/img/' + imgList[index].url +'.png')" style="width: 69px">
            <p>{{item.businessName}}</p>
          </div>

        </div>
        <div class="part-btn" v-else>
          <p class="btn" @click="gotoZZ('')">立即申办</p>
        </div>
      </div>
      <div class="part company_name" v-else-if="indexTab == 'tab2'" key="2">
        <p><span style="color: #FF0000">存证</span>公证</p>
        <p style="margin: 20px 0;font-size: 20px">数据存证公证是指将容易被抹灭、篡改的网络数据在产生那一刻开始，存证于公证处的区块链节点上。</p>
        <p style="font-size: 20px">避免发生纠纷后难以提取有效证据，达到事前预防，事后快速出具存证公证书的目的。
        </p>
<!--        <div class="part-cont" v-if="notarList.length >0">-->
<!--          <div class="list" @click="gotoFQ(item.id)" v-for="(item,index) in notarList" :key="index">-->
<!--            <img :src="require('../../static/img/' + imgList[index].url +'.png')" style="width: 69px">-->
<!--            <p>{{item.businessName}}</p>-->
<!--          </div>-->

<!--        </div>-->
        <div class="part-btn ">
          <p class="btn" @click="gotoFQ('')">立即申办</p>
        </div>
      </div>
      <div class="part company_name" v-else-if="indexTab == 'tab3'" key="3">
        <p><span style="color: #FF0000">提存</span>公证</p>
        <p style="margin: 20px 0;font-size: 20px">是公证机关依照法定条件和程序，对交付的提存物进行寄托、保管，
        </p>
        <p style="font-size: 20px"> 并在条件成熟时交付债权人或其他受益人的活动。</p>
        <div class="part-btn">
          <p class="btn" @click="gotoTC('')">立即申办</p>
        </div>
      </div>
      <div class="part company_name" v-else-if="indexTab == 'tab4'" key="4">
        <p><span style="color: #FF0000">公证</span>电子签</p>
        <p style="margin: 20px 0;font-size: 20px">公证电子签名利用电子公证技术将公证机构设置为多方节点的其中一个，
        </p>
        <p style="font-size: 20px">由公证机构参与、见证并且为用户的签名提供公证证明，为企业提供一步到位的抗抵赖的签署服务。</p>
        <div class="part-btn">
          <p class="btn" @click="gotoDZQ('')">立即申办</p>
        </div>
      </div>
      <div class="part company_name" v-else key="0">
        <p><span style="color: #FF0000">公证</span>取证</p>
        <p style="margin: 20px 0;font-size: 20px">公证取证是指由公证机构依法对特定证据进行固定、保全的过程，以确保证据的真实性、合法性和有效性。
        </p>
        <p style="font-size: 20px">这一程序常见于法律纠纷中，尤其是在证据可能灭失或难以获取的情况下，通过公证手段强化证据的法律效力。</p>
        <div class="part-btn">
          <p class="btn" @click="gotoCZ('')">立即申办</p>
        </div>
      </div>
    </div>
    <div class="footer2">
      <div class="list">
        <div class="li btn" v-for="(item, index) in tabs.filter(item => !item.menuCode || (item.menuCode & showMenus) == item.menuCode)" :class="{'active' : menuIndex === index}"
             @click="changeTab(item, index)">
          <img :src="item.img">
          <p>{{item.desc}}</p>
        </div>

      </div>

      <div class="right-li"
           style="flex-direction: column;font-size: 12px;text-align: right;width: 250px;cursor: unset;background: unset">
        <p style="width:100%;text-align: end">{{systemConfig.notaryName}}</p>
        <p style="width:100%;margin: 5px 0;text-align: end">咨询电话：{{systemConfig.notaryPhone}}</p>
        <p style="width:100%;text-align: end">友情链接:<a href="https://www.ebaoquan.org/"
                                                      style="color: #fff;font-size: 12px;margin-left: 10px">易保全</a>
          <a href="https://www.junziqian.com/" style="color: #fff;font-size: 12px;margin: 0 10px">君子签</a>
          <a href="https://www.wbq360.com/" style="color:#fff;font-size: 12px">微版权</a></p>
      </div>
    </div>


  </div>
  <div class="notaria-container" v-else-if="systemConfig.indexStyle == 4">
    <IndexHeader ref="IndexHeader"></IndexHeader>
    <div class="indexStyle4">
      <div class="part1"
           :style="{backgroundImage: 'url(' + (systemConfig.indexHeaderImgUrl ? systemConfig.indexHeaderImgUrl : '../../static/img/bg.png') + ')', backgroundSize:'100% 100%',repeat:'no-repeat',}">
        <div class="left company_name" key="4">
          <p class="p1">一站式电子数据存证公证平台</p>
          <p class="p2">集电子签署、电子数据取证、电子数据存证公证为一体，全方位业务支持</p>
        </div>
        <div class="right">
          <p class="title">用户端登录</p>
          <el-form
            autocomplete="on"
            :model="loginForm"
            :rules="loginRules"
            ref="loginForm"
            label-position="left"
            label-width="0px"
            class=" login-form"
          >

            <el-form-item prop="username">
              <el-input
                clearable
                name="username"
                type="text"
                v-model="loginForm.username"
                autocomplete="on"
                placeholder="请输入账号(邮箱、手机号)"
                trigger-on-focus="false"
              >
              <span slot="prefix">
                  <img src="../../static/img/indexStyle3/user.png" alt="账号"><span
                style="margin: 0 5px"> | </span></span>

              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                name="password"
                :type="pwdType"
                v-model="loginForm.password"
                autocomplete="on"
                placeholder="请输入密码"
                show-password
              >
                  <span slot="prefix">
                  <img src="../../static/img/indexStyle3/pwd.png" alt="密码"> <span
                    style="margin: 0 5px"> | </span> </span>
              </el-input>

            </el-form-item>
            <el-form-item v-show="showCode">
              <el-input
                type="text"
                placeholder="请输入验证码"
                v-model="code" maxlength="4"
                style="width: 60%"
              >
                <span slot="prefix">
                  <img src="../../static/img/indexStyle3/code.png" alt="验证码"> <span
                  style="margin: 0 5px"> | </span> </span>
              </el-input>
              <img :src="'data:image/png;base64,'+imgCode"
                   style="cursor: pointer;float: right;margin-right: 8px;width: 100px;height: 40px"
                   @click="validCode">
            </el-form-item>

            <el-form-item>
              <el-button
                class="login"
                :loading="loading"
                @click.native.prevent="handleLogin"
              >登&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录
              </el-button>
            </el-form-item>
            <div class="forgetPwd" style="text-align: center">
              <router-link style="color:#008FFF;font-size: 14px;" :to="{path: `registry?type=${systemConfig.indexStyle}`}">
                立即注册
              </router-link>
            </div>
          </el-form>

        </div>
      </div>
      <div class="part2">
        <p class="title">核心服务</p>
        <div class="tab">
          <ul class="tab-ul">
            <li v-for="(item,index) in tabPaneList" :key="index"
                :class="nIndex==index ? 'tabActive':''"
                @click="nIndex=index" @mouseenter="nIndex = index">
              <img :src='item.img'>
              <p style="font-weight: 600">{{item.title}}</p>
              <img class="jt" v-show="nIndex==index" src="../../static/img/indexStyle3/jt.png"/>

            </li>
          </ul>
          <!--          内容-->
          <div v-for="(item,index) in tabContent" :ket="index" class="cont" v-show="nIndex==index">
            <div class="c-left">
              <p class="c-title">{{item.title}}</p>
              <p class="line"></p>
              <p class="c-cont">{{item.cont}}</p>
            </div>
            <div class="c-right">
              <img :src="item.img">
            </div>

          </div>
        </div>
      </div>
      <div class="part3">
        <p class="youshi">系统优势</p>
        <ul>
          <li class=" li1" :class="showDD1 ? 'tab-con':'li1'"
              @mouseenter="showDD1 = true,showDD2 = false,showDD3 = false" @mouseleave="showDD1 = false">
            <img src="../../static/img/indexStyle3/li11.png">
            <p class="title3">本地化部署 数据安全</p>
            <p class="cont">数据运用国密级加密算法，实时存储在公证处指定服务器，完全由公证处自己掌控，保障数据完整不会丢失，真实不可篡改。</p>

          </li>
          <li class="li2" :class="showDD2 ? 'tab-con':'li2'" @mouseenter="showDD2=true,showDD1=false,showDD3=false"
              @mouseleave="showDD2=false">
            <img src="../../static/img/indexStyle3/li22.png">
            <p class="title3">全流程存证记录</p>
            <p class="cont">接入权威司法区块链，电子签署、数据存证、取证过程、操作时间、操作地点等真实信息通过哈希摘要等方式，实时同步到区块链中，实现存证、取证、签署全流程记录。</p>

          </li>
          <li class="li3" :class="showDD3 ? 'tab-con':'li3'" @mouseenter="showDD3=true,showDD2=false,showDD1=false"
              @mouseleave="showDD3=false">
            <img src="../../static/img/indexStyle3/li33.png">
            <p class="title3">多节点司法见证</p>
            <p class="cont">联合工信部、仲裁委、版权保护中心等权威机构，进行多节点司法记录，确保电子数据的可靠和真实性。</p>

          </li>
        </ul>
      </div>
      <div class="part4">
        <p class="title1">区块链存证</p>
        <p class="title2">线下的公证申请材料过多，归档分类工作复杂且繁琐，还不可避免的出现材料错漏，文件被算改等情况</p>
        <div class="dec">
          <div class="dec-left">
            <img src="../../static/img/indexStyle3/part4-left.png">

          </div>
          <div class="dec-right">
            <p class="p1">
              {{systemConfig.notaryName}}公证系统利用区块链技术结合易保全自有专利，联合多家公证处、仲裁委、法院、司法鉴定中心、CA机构、版权保护中心等多个节点建成的区块链存证平台。</p>
            <p class="p2">
              公证系统中每份材料、公证书、申请人附件、回访视频记录，均会通过区块链同步上链存证，保障了上链电子数据的安全性、客观性、真实性，
              并实时将存证数据同步至各节点机构，实现通过区块链存证备案号在各节点时实可查已存证数据的上链情况，也为数据存证后出现纠纷等情况提供可信的电子证据。
            </p>
          </div>
        </div>

      </div>
      <div class="footer">
        <div style="width: 1200px;justify-content: space-between;display: flex;margin: 0 auto">
          <div class="footer-left">
            <p class="name">{{systemConfig.notaryName}}</p>
            <p class="p">咨询电话：{{systemConfig.notaryPhone}}</p>
            <p class="p">本处地址：{{systemConfig.notaryAddress}}</p>
            <p class="p">办公时间：（周一至周五）上午 : 9:00-12:00 / 下午 : 15 : 00-18:00</p>

          </div>
          <div class="footer-right">
            <div style="width:100%">
              <p style="font-size: 24px;margin-bottom: 20px">友情链接:</p>
              <a href="https://www.ebaoquan.org/"
                 style="color: #fff;font-size: 24px;border-bottom: 2px solid #fff">易保全</a>
              <a href="https://www.junziqian.com/"
                 style="color: #fff;font-size: 24px;border-bottom: 2px solid #fff;margin: 0 20px">君子签</a>
              <a href="https://www.wbq360.com/" style="color:#fff;font-size: 24px;border-bottom: 2px solid #fff">微版权</a>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import config from '../config';
  import httpServe from '../http/http-server'
  import IndexHeader from '../components/IndexHeader';
  import IndexFooter from '../components/indexFooter';
  import Swiper from 'swiper';
  import 'swiper/css/swiper.css';
  import store from "../store";
  import {mapMutations, mapState} from 'vuex';
  import {username, password} from "@/utils/validate";
  import httpServer from "../http/http-server";
  import Cookies from 'js-cookie'


  export default {
    name: 'NotariaIndex',
    components: {
      IndexHeader, IndexFooter
    },
    data() {
      return {
        nIndex: 0,
        showDD1: false,
        showDD2: false,
        showDD3: false,
        modelShow: false,
        gennerList: [],//自助列表
        notarList: [],//赋强列表
        imgList: [
          {url: 'zz1'},
          {url: 'zz2'},
          {url: 'zz3'},
        ],
        bgImg: '',
        headerBackgroundColor: 'unset',
        menuBackgroundColor: 'unset',
        defaultTextColor: '#fff',
        txtTitle: '2',
        systemConfig: {},
        btnColor: '2',
        indexTab: 'tab1',
        menuIndex: 0,
        tabs: [
          {
            id: 'tab1',
            desc: '常规公证',
            img: require('../../static/img/notariaIndex/genner.png'),
            menuCode: 2
          },
          {
            id: 'tab2',
            desc: '存证公证',
            img: require('../../static/img/notariaIndex/fuqiang.png'),
            menuCode: 24
          },
          {
            id: 'tab3',
            desc: '提存公证',
            img: require('../../static/img/notariaIndex/cunzheng.png'),
          },
          {
            id: 'tab4',
            desc: '公证电子签',
            img: require('../../static/img/notariaIndex/dianziqian.png'),
            menuCode: 4
          },
          {
            id: 'tab5',
            desc: '公证取证',
            img: require('../../static/img/notariaIndex/ticun.png'),
            menuCode: 32
          },
        ],
        tabPaneList: [
          {
            img: require('../../static/img/indexStyle3/dzqz.png'),
            title: '电子签章'
          },
          {
            img: require('../../static/img/indexStyle3/wyqz.png'),
            title: '网页取证'
          },
          {
            img: require('../../static/img/indexStyle3/lpqz.png'),
            title: '录屏取证'
          },
          {
            img: require('../../static/img/indexStyle3/czgz.png'),
            title: '存证公证'
          }
        ],
        tabContent: [
          {
            title: '公证+电子合同',
            cont: '在公证处的指导和监督下，通过区块链技术为用户提供身份认证、合同编辑、合同发起、在线签署合同管理，司法鉴定及其他法律服务等合同全生命周期管理服务，实现合同签署管理全流程存证记录，保障合同可靠、真实、不可算改。',
            img: require('../../static/img/indexStyle3/dzqz-right.png'),
          },
          {
            title: '证据固化 司法有效',
            cont: '网页取证指按照用户提供的链接对链接页面进行快照抓取并存证至区块链，\n' +
              '支持连续截屏、批量取证、代他人取证等。',
            img: require('../../static/img/indexStyle3/wyqz-right.png'),
          },
          {
            title: '取证环境清洁   证据有效可被采信',
            cont: '对互联网上发生的侵权事实（包括电商平台、视频直播、音频、社交软件上的聊天\n' +
              '记录、图片文章等内容）第一时间进行录屏取证，并利用区块链技术固化保全，将\n' +
              '含有侵权内容的电子数据生成不可否认和无法篡改的电子证据，便于举证维权。',
            img: require('../../static/img/indexStyle3/lpqz-right.png'),
          },
          {
            title: '创新存证方式   全方位保障数据安全',
            cont: '运用可信时间戳、哈希值校验、区块链等证据收集、固定和防篡改的司法级\n' +
              '技术手段，将容易被抹灭、篡改的网络数据在产生那一刻起便立即对该数据\n' +
              '权益进行固化保护，防篡改。',
            img: require('../../static/img/indexStyle3/czgz-right.png'),
          },

        ],
        loginForm: {
          username: "",
          password: "",
          imgCode: "",
          imgToken: "",
          tokenValiCode: ""
        },
        loading: false,
        pwdType: "password",
        imgPath: "",
        showCode: false,
        code: '',
        imgCode: '',
        loginRules: {
          username: [
            {
              trigger: "blur",
              validator: username
            }
          ],
          password: [
            {
              trigger: "blur",
              validator: password
            }
          ],
        },
        showMenus: 63,
      }
    },
    created() {

      this.systemConfig = this.$store.getters.systemConfig
      if(config&&config.domain&& config.domain.menus){
        this.showMenus = config.domain.menus
      }
    },
    mounted() {
      this.queryHotMatter()
      var data = localStorage.getItem('systemConfig');
      if (data != null) {
        // 本地存储里面的数据是字符串格式的，但我们需要的是对象格式
        this.systemConfig = JSON.parse(data)
        // return  this.systemConfig;
      } else {
        return {};
      }
      this.showMap()

    },
    watch: {
      '$store.getters.systemConfig': {
        handler(val) {
          this.systemConfig = this.$store.getters.systemConfig
          this.showMap()
        },
        deep: true
      }
    },
    methods: {
      ...mapMutations(['SET_Type']),
      cancelModel() {
        this.modelShow = false
      },
      notariaLogin() {
        location.href = config.domain.baseURL.replace('web', 'boss')
      },

      showMap() {
        // let notaryName = this.$store.getters.systemConfig.notaryName
        // let lng = this.$store.getters.systemConfig.longitudeAndLatitude.indexOf(',') > -1 ? this.$store.getters.systemConfig.longitudeAndLatitude.split(',')[0] : this.$store.getters.systemConfig.longitudeAndLatitude.split('，')[0]
        // let lat = this.$store.getters.systemConfig.longitudeAndLatitude.indexOf(',') > -1 ? this.$store.getters.systemConfig.longitudeAndLatitude.split(',')[1] : this.$store.getters.systemConfig.longitudeAndLatitude.split('，')[1]
        if(!this.systemConfig.longitudeAndLatitude) return
        let notaryName = this.systemConfig.notaryName
        let lng = this.systemConfig.longitudeAndLatitude.indexOf(',') > -1 ? this.systemConfig.longitudeAndLatitude.split(',')[0] : this.systemConfig.longitudeAndLatitude.split('，')[0]
        let lat = this.systemConfig.longitudeAndLatitude.indexOf(',') > -1 ? this.systemConfig.longitudeAndLatitude.split(',')[1] : this.systemConfig.longitudeAndLatitude.split('，')[1]

        //创建和初始化地图函数：
        function initMap() {
          createMap();//创建地图
          setMapEvent();//设置地图事件
          addMapControl();//向地图添加控件
          addMapOverlay();//向地图添加覆盖物
        }

        function createMap() {
          // console.log( this.$store.getters.systemConfig.longitudeAndLatitude.split('，')[0],'this.lat')
          console.log(lng, 'lngww111111111')
          map = new BMap.Map("map");
          map.centerAndZoom(new BMap.Point(lng, lat), 19); //修改经纬度
        }

        function setMapEvent() {
          map.enableScrollWheelZoom();
          map.enableKeyboard();
          map.enableDragging();
          map.enableDoubleClickZoom()
        }

        function addClickHandler(target, window) {
          target.addEventListener("click", function () {
            target.openInfoWindow(window);
          });
        }

        function addMapOverlay() {
          console.log(lng, 'lngwwsdfgdsfg')
          var markers = [
            {
              content: `${notaryName}`,
              title: "我的标记",
              imageOffset: {width: 0, height: 3},
              position: {lat: lat, lng: lng} //修改经纬度
            }
          ];
          for (var index = 0; index < markers.length; index++) {
            var point = new BMap.Point(markers[index].position.lng, markers[index].position.lat);
            var marker = new BMap.Marker(point, {
              icon: new BMap.Icon("https://api.map.baidu.com/lbsapi/createmap/images/icon.png", new BMap.Size(20, 25), {
                imageOffset: new BMap.Size(markers[index].imageOffset.width, markers[index].imageOffset.height)
              })
            });
            var label = new BMap.Label(markers[index].title, {offset: new BMap.Size(25, 5)});
            var opts = {
              width: 200,
              title: markers[index].title,
              enableMessage: false
            };
            var infoWindow = new BMap.InfoWindow(markers[index].content, opts);
            marker.setLabel(label);
            addClickHandler(marker, infoWindow);
            map.addOverlay(marker);
          }
          ;
        }

        //向地图添加控件
        function addMapControl() {
          var scaleControl = new BMap.ScaleControl({anchor: BMAP_ANCHOR_BOTTOM_LEFT});
          scaleControl.setUnit(BMAP_UNIT_IMPERIAL);
          map.addControl(scaleControl);
          var navControl = new BMap.NavigationControl({
            anchor: BMAP_ANCHOR_TOP_LEFT,
            type: BMAP_NAVIGATION_CONTROL_LARGE
          });
          map.addControl(navControl);
          var overviewControl = new BMap.OverviewMapControl({anchor: BMAP_ANCHOR_BOTTOM_RIGHT, isOpen: true});
          map.addControl(overviewControl);
        }

        var map;
        initMap();
      },

      gotoZZ(busiId) {
        this.$router.push('/general-notarial-apply?type=zz&busiId=' + busiId)
        this.SET_Type('zz')
      },
      gotoFQ(busiId) {
        this.$router.push('/Assign-apply?type=fq&busiId=' + busiId)
        this.SET_Type('fq')
      },
      gotoCZ() {
        this.$router.push('/notarial-certificate?type=cz')
        this.SET_Type('cz')

      },
      gotoDZQ(){
        this.$router.push('/waitMatter?type=dzq')
        this.SET_Type('dzq')
      },
      gotoTC(){
        this.$message.warning('若需办理，请联系公证处进行咨询 ' + (this.$store.getters.systemConfig.notaryPhone || '' ))
      },
      queryHotMatter() {
        httpServe.hotMatter().then(res => {
          if (res.success) {
            this.gennerList = res.data.filter(i => i.type == 2)
            this.notarList = res.data.filter(i => i.type == 1)
            console.log(1111111111111111111,res.data)
          }
        })
      },
      changeTab(item, index) {
        this.indexTab = item.id
        if (this.menuIndex != index) {
          this.menuIndex = index
        } else {
          this.menuIndex = null
          this.indexTab = null
        }

      },
      async handleLogin() {
        //判断
        const name = this.loginForm.username;
        const pwd = this.loginForm.password;
        this.$refs.loginForm.validate(valid=>{
          if(valid){
        httpServer.login({
          userName: name,
          password: pwd,
          valiCode: this.code || '',
          token: this.codeToken || ''
        }).then(res => {
          if (res.success) {
            if (!this.$store.state.type) {
              this.SET_Type('cz')
            }
            this.$router.push('/waitMatter')
            // 每天首次登录弹出快速填写提示框 1:弹出 0:不弹出
            if (Cookies.get(this.$store.getters.profile.userId) === undefined) {
              let date = new Date()
              date.setDate(date.getDate() + 1)
              date.setHours(0)
              date.setMinutes(0)
              date.setSeconds(0)
              let expires = date.getTime() - new Date().getTime()
              Cookies.set(res.data.userId, 1, {expires: expires})
            }


          } else {
            this.validCode()
            if (res.code) {
              this.showCode = true
            }
            this.$message({
              showClose: true,
              message: res.message,
              type: 'error'
            })
          }
        }).catch(err => {
          console.log(err)
        })
        }else{
          return false;
        }
        })

        if (this.rememberMe) {  //设置要记住的账户，密码
          localStorage.setItem("user", this.loginForm.username)
          localStorage.setItem("pwd", this.loginForm.password)
        } else {
          localStorage.removeItem("user");
          localStorage.removeItem("pwd");
        }
      },
      validCode() {
        httpServer.valicode().then(res => {
          if (res.success) {
            this.imgCode = res.data.imgBytes;
            this.codeToken = res.data.token
          }
        }).catch(err => {
          console.log(err)
        })
      },


    }
  };
</script>

<style scoped lang="less">
  .notaria-container {
    width: 100%;
    height: 100%;

    .banner {
      height: 600px;
      width: 100%;
      display: flex;
      align-items: center;
      position: relative;

      .left {
        color: #fff;
        margin-left: 8%;

        .p1 {
          margin-bottom: 50px;
          font-size: 48px;

        }

        .p2 {
          font-size: 18px;
        }

      }
    }

    .cards {
      margin: 0 auto !important;
      margin-top: 120px !important;
      width: 1200px !important;
      height: 460px;
      display: flex;
      justify-content: space-between;

      .card {
        border: 1px solid #2c69ec;
        box-sizing: border-box;
        padding: 27px 18px 37px 18px;
        width: 19%;
        min-width: 200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        >img{
          width: 46px;
        }

        .card-title {
          margin: 13px 0 30px 0;
          font-size: 26px;
          font-weight: 500;
        }

        .card-content {
          font-size: 16px;
          height: 205px;
          /*line-height: 30px;*/
          margin-bottom: 30px;
        }

        .btn-box {
          width: 100%;
          display: flex;
          justify-content: space-around;

          .card-btn {
            color: #d0021b;
            width: 110px;
            text-align: center;
            border: 1px solid #d0021b;
            border-radius: 6px;
          }
        }

      }
    }

    .map {
      margin-top: 140px;
      min-height: 520px;
      display: flex;
      justify-content: center;
      align-items: center;

      background-size: cover;

      .map-box {
        width: 1200px;
        min-height: 345px;
        background: rgba(8, 8, 8, 0.4);
        box-sizing: border-box;
        padding: 30px 0;

        .map-info {
          width: 280px;
          height: 280px;
          vertical-align: top;
          display: inline-flex;
          justify-content: space-between;
          flex-direction: column;

          .info-item {
            display: flex;
            justify-content: start;
            vertical-align: top;

            .info-incon {
              margin: 10px;

              img {
                width: 20px;
                height: 20px;
              }
            }

            .info-content {
              color: #fff;
              display: flex;
              font-size: 14px;
              line-height: 22px;
              flex-direction: column;

              .content-title {
                margin-top: 5px;
              }
            }
          }
        }
      }
    }


    .fqgz {
      height: 430px;
      border-radius: 10px;
      box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.12);
      background: url('../../static/img/fqbg.png') no-repeat;
      background-size: cover;
    }

    .fqgz:hover {
      box-shadow: 0px 3px 16px rgba(20, 101, 192, 0.36);
    }

    .fqgz:hover .fqbg {
      background: rgba(2, 224, 235, 0.5);
    }

    .fqbg {
      width: 100%;
      height: 308px;
      border-radius: 10px 10px 0 0;
    }

    .sjcz {
      height: 430px;
      border-radius: 10px;
      margin: 0 50px;
      box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.12);
      background: url('../../static/img/sjczbg.png') no-repeat;
      background-size: cover;
    }

    .sjcz:hover {
      box-shadow: 0px 3px 16px rgba(20, 101, 192, 0.36);
    }

    .sjcz:hover .sjczbg {
      background: rgba(2, 224, 235, 0.5);
    }

    .sjczbg {
      height: 308px;
      border-radius: 10px 10px 0 0;
    }

    .zzgz {
      height: 430px;
      border-radius: 10px;
      box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.12);
      background: url('../../static/img/zzbg.png') no-repeat;
      background-size: cover;
    }

    .zzgz:hover {
      box-shadow: 0px 3px 16px rgba(20, 101, 192, 0.36);
    }

    .zzgz:hover .zzbg {
      background: rgba(2, 224, 235, 0.5);
    }

    .zzbg {
      height: 308px;
      border-radius: 10px 10px 0 0;
    }

    .loginbtn {
      width: 35%;
      height: 32%;
      border-radius: 100px;
      border: 1px solid #1465C0;
      color: #1465C0;
      font-size: 16px;
      font-weight: 600;
      line-height: 15px;
      text-align: center;
      cursor: pointer;
    }

    .loginbtn:hover {
      background: #1465C0;
      color: #ffffff;
    }

    .cancelbtn {
      display: block;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.25);
      border: 0;
      position: absolute;
      top: 8px;
      right: 150px;
    }

    .cancelbtn:hover {
      color: #1465C0;
    }

    .confirmbtn {
      width: 80px;
      height: 32px;
      background: #1465C0;
      font-size: 14px;
      font-weight: 400;
      line-height: 8px;
      color: #ffffff;
      margin-top: 14px;
      margin-left: 370px;
    }

    .confirmbtn:hover {
      background: #014A98;
    }

    .headerTitle {
      cursor: pointer;
    }

    .headerTitle:hover {
      background: rgba(0, 224, 235, 0.5);
    }
  }

  @media screen and (max-width: 1600px) {
    .cards {
      margin-left: 0 !important;
      margin-right: 0 !important;
      width: 100% !important;
      min-width: 1220px !important;
    }
  }

  .new-content {
    margin: 0 auto;
    width: 80%;
    text-align: center;

    .new-card {
      margin-top: 100px;

      .title-p {
        font-size: 24px;
        color: #0E4A95;
        font-weight: bold;
        margin-bottom: 30px;
      }

      .cont-p {
        font-size: 12px;
        color: #555;
        font-weight: 400;
        line-height: 28px;
      }

      .part {
        display: flex;
        justify-content: center;
        margin-top: 60px;

        .list {
          width: 200px;
          cursor: pointer;
          text-align: center;

          img {
            margin-bottom: 10px;
          }

          p {
            font-size: 16px;
            color: #555;
            font-weight: 400;
          }
        }

        .btn {
          color: #E23E3E;
          border: 1px solid #E23E3E;
          cursor: pointer;
          padding: 10px;
          border-radius: 2px 2px 2px 2px;
        }
      }
    }

    .fq-bj {
      background: url('../../static/img/fq-bj.png');
      max-width: 1200px;
      margin: 0 auto;
      background-size: cover;
      padding: 20px;
      height: 280px;
    }
    .gz-dzq {
      background: url('../../static/img/gz-dzq.png');
      max-width: 1200px;
      margin: 0 auto;
      background-size: cover;
      padding: 20px;
      height: 280px;
    }
  }

  .footer2 {
    width: 100%;
    height: 80px;
    background: rgba(256, 256, 256, 0.18);
    bottom: 0px;
    position: fixed;
    display: flex;

    .right-li {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 40px;
      color: #fff;
    }

    .list {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;


      .li {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        width: 220px;
        height: 80px;
        color: #fff;


        &:hover {
          cursor: pointer;

        }

        img {
          width: 32px;
          height: 32px;
          margin-right: 10px;
        }
      }

      .btn {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        width: 220px;
        height: 80px;
        color: #fff;
      }

      .btn:after, .btn:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 100%;
        background: rgba(256, 256, 256, 0.18);
        z-index: -2;
        border-radius: 4px;
        color: #fff;
      }

      .btn:hover {
        z-index: 1;
        background: transparent;
      }

      .btn:before {
        color: #fff;
        transition: .3s;
        background: rgba(256, 256, 256, 0.18);
        z-index: -1;
      }

      .btn:hover:after, .btn:hover:before {
        width: 100%;
      }

    }

    .active {
      border-top: 1px solid #FF0000;
      background: rgba(256, 256, 256, 0.18);
      border-radius: 0px;

    }
  }

  .cont2 {

    .part {
      font-size: 70px;
      color: #fff;
      margin-left: 20%;
      margin-top: 8%;

      .part-cont {
        display: flex;
        margin-top: 60px;

        .list {
          width: 200px;
          cursor: pointer;
          text-align: center;


          img {
            margin-bottom: 10px;
          }

          p {
            font-size: 16px;
            color: #fff;

            font-weight: 400;
          }
        }

      }


    }

    .part-btn {
      margin-top: 8%;
      width: 120px;
      text-align: center;

      .btn {
        font-size: 16px;

        color: #fff;
        background-color: #E80000;
        cursor: pointer;
        padding: 15px 20px;
        border-radius: 2px 2px 2px 2px;

        &:hover {
          background-color: #FF0000;
        }
      }
    }
  }

  .indexStyle4 {
   /deep/ input:autofill, select:autofill, textarea:autofill{
      -webkit-text-fill-color:#666464 !important
    }
    /deep/ input:-webkit-autofill, select:-webkit-autofill, textarea:-webkit-autofill{
      -webkit-text-fill-color:#666464 !important
    }
    .part1 {
      height: 600px;
      width: 100%;
      display: flex;
      align-items: center;
      position: relative;

      .left {
        color: #fff;
        margin-left: 8%;

        .p1 {
          margin-bottom: 50px;
          font-size: 48px;

        }

        .p2 {
          font-size: 18px;
        }

      }

      .right {
        width: 360px;
        height: 375px;
        background: #fff;
        padding: 0 35px;
        box-sizing: border-box;
        position: absolute;
        right: 10%;
        border-radius: 10px;

        .title {
          font-size: 24px;
          color: #000;
          font-weight: 500;
          text-align: center;
          margin: 30px 0 25px;
        }

        .login {
          width: 100%;
          background-color: #008FFF;
          font-size: 16px;
          color: #fff;
        }
      }

      /deep/ .el-input--prefix .el-input__inner {
        padding-left: 50px !important;
      }

      /deep/ .el-input__prefix {
        left: 15px !important;
      }

    }

    .part2 {
      background: url("../../static/img/indexStyle3/part2-bg.png") no-repeat;
      /*height: 600px;*/
      background-size: 100% 100%;
      padding-bottom: 100px;

      .title {
        text-align: center;
        font-size: 38px;
        padding: 98px 0 70px;
      }

      .tab {
        .tab-ul {
          display: flex;
          width: 1200px;
          margin: 0 auto;
          text-align: center;
          height: 350px;

          li {
            width: 25%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: relative;
            -webkit-transition: width 2s, height 2s, -webkit-transform 2s; /* For Safari 3.1 to 6.0 */
            transition: width 2s, height 2s, transform 2s;

            .jt {
              position: absolute;
              bottom: -10px;
            }

            &:hover {
              cursor: pointer;
              background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 50%, #DBE8FF 100%);
              box-shadow: 0px 0px 15px 1px rgba(0, 88, 201, 0.15);
              border-bottom: 2px solid #003CFF;

              .jt {
                display: block;
              }
            }

          }


        }

        .tabActive {
          cursor: pointer;
          background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 50%, #DBE8FF 100%);
          box-shadow: 0px 0px 15px 1px rgba(0, 88, 201, 0.15);
          border-bottom: 2px solid #003CFF;

          .jt {
            display: block;
          }
        }

        .cont {
          width: 1200px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          padding: 52px 60px;
          margin-top: 40px;
          box-sizing: border-box;
          background: linear-gradient(180deg, #DBE8FF 0%, #FFFFFF 83%, #FFFFFF 100%);
          box-shadow: 0px 0px 15px 1px rgba(0, 88, 201, 0.15);
          position: relative;

          .c-left {
            height: 80%;
            width: 50%;

            .c-title {
              font-size: 24px;
              font-weight: 600;
            }

            .line {
              width: 29px;
              height: 3px;
              background: #000;
              margin: 25px 0;
            }

            .c-cont {
              font-size: 14px;
              line-height: 25px;
            }

          }

          .c-right {
            flex: 1;
            text-align: right;
          }


        }
      }

    }

    .part3 {
      background: #E1EFFF;
      padding-bottom: 100px;


      .youshi {
        text-align: center;
        font-size: 38px;
        padding: 115px 0 65px;
        box-sizing: border-box;
      }

      ul {
        display: flex;
        width: 1200px;
        margin: 0 auto;
        justify-content: space-between;

        li {
          text-align: center;
          padding: 78px 60px 0;
          box-sizing: border-box;

          .title3 {
            color: #fff;
            font-size: 26px;
            margin-bottom: 30px;
          }

          .cont {
            font-size: 18px;
            color: #fff;
            line-height: 22px;

          }
        }

        .li1 {
          width: 32%;
          height: 470px;
          background: url("../../static/img/indexStyle3/li1.png") no-repeat;
          background-size: 100% 100%;

        }

        .li2 {
          width: 32%;
          height: 470px;
          background: url("../../static/img/indexStyle3/li2.png") no-repeat;
          background-size: 100% 100%;
        }

        .li3 {
          width: 32%;
          height: 470px;
          background: url("../../static/img/indexStyle3/li3.png") no-repeat;
          background-size: 100% 100%;
        }
      }
    }

    .part4 {
      background: url("../../static/img/indexStyle3/part4-bg.png") no-repeat;
      background-size: 100% 100%;

      .title1 {
        text-align: center;
        font-size: 38px;
        margin-top: 100px;
        margin-bottom: 30px;
      }

      .title2 {
        font-size: 16px;
        text-align: center;
        margin-bottom: 80px;
      }

      .dec {
        background: linear-gradient(180deg, #fff 0%, #FFFFFF 70%, #A1BDFD 100%);
        box-shadow: 0px 0px 15px 1px rgba(0, 88, 201, 0.15);
        width: 1200px;
        min-height: 500px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        position: relative;
        z-index: 1;
        border-radius: 10px;
      }

      .dec-left {
        width: 60%;
        text-align: right;
      }

      .dec-right {
        flex: 1;
        font-size: 16px;
        line-height: 28px;
        padding: 70px;

        .p1 {
          margin-bottom: 30px;
        }
      }
    }

    .footer {
      background: url("../../static/img/indexStyle3/footer.png") no-repeat;
      /*height: 320px;*/
      margin-top: -70px;
      padding-top: 120px;
      color: #fff;
      padding-bottom: 50px;

      .footer-left {
        .name {
          font-size: 24px;
          margin-bottom: 22px;
        }

        .p {
          font-size: 16px;
          margin-bottom: 12px;
        }
      }

      .footer-right {


      }
    }
  }


  /*定义一个名字为lefteaseinAnimate动画，实现从页面的左边淡入页面效果,加key*/
  @keyframes lefteaseinAnimate {
    0% {
      transform: translateX(-2000px);
      opacity: 0;
    }
    /*在0%时设置文字在想X轴-2000px位移处（左边），透明度为0，也就是看不见文字*/
    100% {
      transform: translateX(0px);
      opacity: 1;
    }
    /*在100%时设置文字在想X轴0px位移处，也就是原始布局的位置，透明度为1，也就是文字可以看见了*/
  }

  @-webkit-keyframes lefteaseinAnimate {
    0% {
      -webkit-transform: translateX(-2000px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateX(0px);
      opacity: 1;
    }
  }

  @-o-keyframes lefteaseinAnimate {
    0% {
      -webkit-transform: translateX(-2000px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateX(0px);
      opacity: 1;
    }
  }

  @-ms-keyframes lefteaseinAnimate {
    0% {
      -webkit-transform: translateX(-2000px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateX(0px);
      opacity: 1;
    }
  }

  @-moz-keyframes lefteaseinAnimate {
    0% {
      -webkit-transform: translateX(-2000px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateX(0px);
      opacity: 1;
    }
  }

  .company_name {
    animation: lefteaseinAnimate 1s ease 1; /*调用已定义好的动画lefteaseinAnimate，全程运行时间1S，进入的速度曲线为ease，只播放一次*/
    -webkit-animation: lefteaseinAnimate 1s ease 1;
    -ms-animation: lefteaseinAnimate 1s ease 1;
    -o-animation: lefteaseinAnimate 1s ease 1;
    -moz-animation: lefteaseinAnimate 1s ease 1;

    /*规定动画的最后状态为结束状态*/
    animation-fill-mode: forwards;
    -webkit-animation-fill-mode: forwards;
    -o-animation-fill-mode: forwards;
    -ms-animation-fill-mode: forwards;
    -moz-animation-fill-mode: forwards;
  }


  @-webkit-keyframes zy {
    10% {
      transform: rotate(3deg);
    }
    20% {
      transform: rotate(-3deg);
    }
    30% {
      transform: rotate(2deg);
    }
    40% {
      transform: rotate(-2deg);
    }
    50%, 100% {
      transform: rotate(0deg);
    }
  }

  /* 使用 */
  .tab-con {
    animation: zy 2.5s .15s linear infinite;
    /*animation: zy 2.5s .15s linear infinite;*/
    /*animation: zy 2.5s .15s linear infinite;*/
    /*animation: zy 2.5s .15s linear infinite;*/
    /* 兼容写法 */
    animation: zy 2.5s .15s linear infinite;
    -moz-animation: zy 2.5s .15s linear infinite; /* Firefox */
    -webkit-animation: zy 2.5s .15s linear infinite; /* Safari and Chrome */
    -o-animation: zy 2.5s .15s linear infinite; /* Opera */
  }


</style>



// WEBPACK FOOTER //
// src/pages/NotariaIndex.vue